import { SET_EMPLOYEE } from "./action";

const initialState = {
  users: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_EMPLOYEE:
      return {
        ...state,
        employee: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
